import { buildColumnDisplayValueComparator } from "../datatable-utils/build-column-display-value-comparator";

const LABEL_COLUMN_ID_PREFIX = "label_";

export const partitionToggleableColumnList = <TColumn extends { id: string; getCanHide: () => boolean }>({
  columnList,
  getDisplayValueForColumn,
}: {
  columnList: readonly TColumn[];
  getDisplayValueForColumn: (columnId: string) => string;
}): { standardColumnList: TColumn[]; labelColumnList: TColumn[] } => {
  const compareByDisplayValue = buildColumnDisplayValueComparator<TColumn>(getDisplayValueForColumn);
  const hideableColumnList = columnList.filter((column) => column.getCanHide());

  return {
    standardColumnList: hideableColumnList
      .filter((column) => !column.id.startsWith(LABEL_COLUMN_ID_PREFIX))
      .sort(compareByDisplayValue),
    labelColumnList: hideableColumnList
      .filter((column) => column.id.startsWith(LABEL_COLUMN_ID_PREFIX))
      .sort(compareByDisplayValue),
  };
};
